import LazyPage from '@classes/lazyPage/LazyPage.tsx';

import PublicI from '../types.ts';

const Index =
    process.env.REACT_APP_SEO === 'true' && require('../components/index/Index.tsx').default;
const Tariffs =
    process.env.REACT_APP_SEO === 'true' && require('../components/tariffs/Tariffs.tsx').default;
const Order =
    process.env.REACT_APP_SEO === 'true' && require('../components/order/Order.tsx').default;
const Contacts =
    process.env.REACT_APP_SEO === 'true' && require('../components/contacts/Contacts.tsx').default;
const Legal =
    process.env.REACT_APP_SEO === 'true' && require('../components/legal/Legal.tsx').default;
const Blog = process.env.REACT_APP_SEO === 'true' && require('../components/blog/Blog.tsx').default;

const pages = {
    'public-index': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-index', Index);
        },
    },
    'public-tariffs': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-tariffs', Tariffs);
        },
    },
    'public-blog': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-blog', Blog);
        },
    },
    'public-legal': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-legal', Legal);
        },
    },
    'public-contacts': {
        render(this: PublicI) {
            return new LazyPage({ context: this }).renderPage('public-contacts', Contacts);
        },
    },
    'public-order': {
        render(this: PublicI) {
            const { user, levels, storePages, tariffsOrder, device, seoData } = this.props;
            const props = { user, levels, storePages, tariffsOrder, device, seoData };

            return new LazyPage({ context: this }).renderPage('public-order', Order, props);
        },
    },
} as const;

export default pages;
